import { Route } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import CustomStoreCatalog from './pages/CustomStoreCatalog';
import Login from './pages/Login';
import Home from './pages/Home';
import RouteWrapper from './components/RouteWrapper';
import ProductDetails from './pages/ProductDetails';
import CustomOrders from './pages/CustomOrder';
import Layout from './components/layout';
import MyProfile from './pages/MyProfile';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import Products from './pages/Products';
import MyCatalog from './pages/MyCatalog';
import OrderSpecifications from './pages/OrderSpecifications';
import OrderConfirmation from './pages/OrderConfirmation';
import CustomerRegister from './pages/CustomerRegister';
import Quotes from './pages/Quotes';
import QuoteNew from './pages/QuoteNew';
import QuoteDetails from './pages/QuoteDetails';
import ServiceNew from './pages/ServiceNew';
import QuoteConfirmation from './pages/QuoteConfirmation';
import ResetPassword from './pages/ResetPassword';
import ResetPasswordPublic from './pages/ResetPasswordPublic';

function App() {
  return (
    <Routes>
      <Route path="/catalogo-parceiro/:slug?" element={<CustomStoreCatalog />} />
      <Route
        path="*"
        element={
          <Layout>
            <Routes>
              <Route path="/" element={<RouteWrapper defaultComponent={<Home />} loggedComponent={<Products />} />} />
              <Route path="/login" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<Products />} />} />

              <Route path="/redefinir-senha" element={<RouteWrapper defaultComponent={<ResetPasswordPublic />} loggedComponent={<ResetPassword />} />} />

              <Route path="/cadastro-de-cliente/:token?" element={<RouteWrapper defaultComponent={<CustomerRegister />} loggedComponent={<Products />} />} />
              <Route path="/meu-catalogo" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<MyCatalog />} />} />
              <Route path="/meu-perfil" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<MyProfile />} />} />
              <Route path="/pedidos" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<Orders />} />} />
              <Route path="/pedido-detalhes/:id" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<OrderDetails />} />} />
              <Route path="/pedido-especificacoes/:id" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<OrderSpecifications />} />} />
              <Route path="/pedido-resultado/:status" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<OrderConfirmation />} />} />

              <Route path="/orcamentos" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<Quotes />} />} />
              <Route path="/orcamento-detalhes/:id" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<QuoteDetails />} />} />
              <Route path="/orcamento-cadatrar" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<QuoteNew />} />} />

              <Route path="/orcamento-resultado/:status" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<QuoteConfirmation />} />} />

              <Route path="/produtos" element={<Products />} />
              <Route path="/produto-detalhes/:id" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<ProductDetails />} />} />
              <Route path="/pedido-personalizado/:id?" element={<RouteWrapper isPrivate defaultComponent={<Login />} loggedComponent={<CustomOrders />} />} />

              <Route path="/servico-novo" element={<RouteWrapper defaultComponent={<Login />} loggedComponent={<ServiceNew />} />} />

              <Route path="*" element={<RouteWrapper defaultComponent={<Home />} loggedComponent={<Products />} />} />
            </Routes>
          </Layout>
        }
      />
    </Routes>
  );
};

export default App;